import cx from 'classnames'
import { FC, Suspense } from 'react'

import Heading from '@/components/Heading'
import ProductLinks from '@/components/Layout/Header/Molecules/HeaderProductLinks'
import '@/components/Layout/Header/Organisms/RecentProducts/RecentProducts.scss'
import ULink from '@/components/Link/ULink'
import { ProductType } from '@/types/product'

type Props = {
  products: ProductType[]
  nextLink?: boolean
  classNames?: (string | { [key: string]: boolean })[]
}

const RecentProducts: FC<Props> = ({ products, nextLink = true, classNames = [] }) => {
  return (
    <div className={cx('c-recentProducts', classNames)}>
      <div className="l-recentProducts__heading">
        <Heading headingType="h2" fontFamily="Goldenbook">
          Recent Product
        </Heading>
        <span className="l-recentProducts__line" aria-hidden="true" />
        <ULink className="l-recentProducts__anchor u-mo-crop u-mo-arrow" href="/products" nextLink={nextLink}>
          <div className="u-mo-crop__container">
            <span className="u-mo-crop__text u-mo-crop__text--inner">View All</span>
            <span className="u-mo-crop__text u-mo-crop__text--outer">View All</span>
          </div>
          <figure>
            <svg viewBox="0 0 12 7" fill="#fff" xmlns="http://www.w3.org/2000/svg" className="l-recentProducts__arrow">
              <path d="M11.0908 3.50005L0.654458 6.8546L4.13324 3.50006L0.654457 0.145509L11.0908 3.50005Z"></path>
            </svg>
          </figure>
        </ULink>
      </div>
      <Suspense>
        <ProductLinks products={products} nextLink={nextLink} />
      </Suspense>
    </div>
  )
}

export default RecentProducts
